/**
 * Intent state pill. The dot pulses for ``processing`` and ``refunding``,
 * the states still waiting on a provider.
 */
import { Badge } from "@/components/ui/badge";
import type { IntentState } from "@/lib/api";
import { INTENT_STATE_BADGE_VARIANT } from "@/lib/state-badges";

const IN_FLIGHT: ReadonlySet<IntentState> = new Set(["processing", "refunding"]);

export function StateBadge({ state }: { state: IntentState }) {
  return (
    <Badge dot pulse={IN_FLIGHT.has(state)} variant={INTENT_STATE_BADGE_VARIANT[state]} className="capitalize">
      {state.replace(/_/g, " ")}
    </Badge>
  );
}
